import React from 'react';
import Button from 'components/Button';
import Icon, { IconsType } from 'components/Icon';
import analyticsManager from 'helpers/analyticsManager';
import { ReviewedMixpanelEvents } from 'helpers/mixpanelReviewedEvents';
import { useStyles } from './wnstn-widget.styles';
import { useWnstnContext } from './wnstn-widget.context';

export const WnstnTriggerButton: React.FC = () => {
    const classes = useStyles();
    const { toggleOpen } = useWnstnContext();

    const handleClick = () => {
        analyticsManager.trackEvent(ReviewedMixpanelEvents.WT_AI_CHAT_BUTTON_CLICKED);
        toggleOpen();
    };

    return (
        <div className={classes.gradientBorder}>
            <Button className={classes.trigger} onClick={handleClick} aria-label="AI Chat">
                <Icon name={IconsType.ai_chat} className={classes.triggerIcon} />
            </Button>
        </div>
    );
};
